import PropTypes from 'prop-types';

import React, { memo } from 'react';
import { List } from 'immutable';

const ErrorList = props => {
  const { errors, ...rest } = props;

  if (errors.size > 0) {
    return (
      <ul {...rest}>
        {errors.map((error, index) => (
          <li key={index} className="text-danger">
            {error}
          </li>
        ))}
      </ul>
    );
  }

  return null;
};

ErrorList.propTypes = {
  errors: PropTypes.instanceOf(List).isRequired,
};

export default memo(ErrorList);
